export const INVALID_EMAIL_ADDRESS = 1015;
